module.exports = "/_next/static/images/digibyte-3f9fde707e30492ffb8a252edb31db53.png";